import {
  STORE_USER,
  USER_EXPIRED,
  LOADING_USER,
  USER_SIGNED_OUT,
  STORE_USER_ERROR,
} from '../types'
import { setTokensH } from '../../redux/slice/auth/set'

export function storeUser(user) {
  setTokensH(user['access_token'])
  return {
    type: STORE_USER,
    payload: user
  }
}

export function loadingUser() {
  return {
    type: LOADING_USER
  }
}

export function storeUserError() {
  return {
    type: STORE_USER_ERROR
  }
}

export function userExpired() {
  return {
    type: USER_EXPIRED
  }
}

export function userSignedOut() {
  return {
    type: USER_SIGNED_OUT
  }
}